import React from 'react'
import { Card, Select, Typography } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStethoscope, faUser, faShield, faPhone, faKey, faClock } from '@fortawesome/free-solid-svg-icons'
import InfoRow from './InfoRow'
import { calculateDuration, generateStatusTag } from '../utils'

const { Title, Text } = Typography

const BookingSummary = ({ recordData, rescheduling, reassigning, handleReassignment, medicalProfessionals, token }) => {
  return (
    <Card
      style={{
        marginBottom: '24px',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
      }}
      bodyStyle={{ padding: '20px' }}
    >
      <Title
        level={5}
        style={{
          margin: '0 0 20px 0',
          color: token.colorText,
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}
      >
        <FontAwesomeIcon icon={faStethoscope} style={{ color: token.colorPrimary }} />
        Booking Summary
      </Title>

      <div style={{ marginBottom: '20px' }}>
        <Text
          strong
          style={{
            display: 'block',
            marginBottom: '8px',
            color: token.colorTextSecondary,
            fontSize: '14px'
          }}
        >
          Doctor:
        </Text>
        <Select
          showSearch
          optionFilterProp='search'
          loading={reassigning}
          onChange={(value) => handleReassignment(value, 'medicalProfRef')}
          style={{ width: '100%' }}
          value={recordData.medicalProfRef}
          size='large'
          options={medicalProfessionals.map((medProf) => ({
            search: `${medProf.firstName} ${medProf.lastName}`,
            label: (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span>
                  {medProf.extraData.profession === 'doctor' ? 'Dr. ' : ''}
                  {medProf.firstName.charAt(0).toUpperCase()}. {medProf.lastName}
                </span>
                {medProf.onDuty && (
                  <span
                    style={{
                      color: token.colorSuccess,
                      fontSize: '10px',
                      fontWeight: 'bold'
                    }}
                  >
                    ON DUTY
                  </span>
                )}
              </div>
            ),
            value: medProf._id
          }))}
        />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
        <InfoRow icon={faUser} label='Patient' value={recordData.patientName} token={token} />
        {!rescheduling && (
          <>
            {/* Custom Status Row with Tag */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '12px 0',
                borderBottom: `1px solid ${token.colorBorderSecondary}`
              }}
            >
              <div
                style={{
                  minWidth: '24px',
                  marginRight: '12px',
                  color: token.colorPrimary
                }}
              >
                <FontAwesomeIcon icon={faShield} />
              </div>
              <div style={{ minWidth: '120px', marginRight: '16px' }}>
                <Text strong style={{ color: token.colorTextSecondary, fontSize: '14px' }}>
                  Status:
                </Text>
              </div>
              <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
                {generateStatusTag(recordData.clinicRecord, recordData.status, recordData.wasNoShow, token)}
              </div>
            </div>
            <InfoRow
              icon={faPhone}
              label='Contact'
              value={recordData.patientRecord.phoneNumber || recordData.patientRecord.tmpPhoneNumber}
              token={token}
            />
            <InfoRow icon={faKey} label='OTP' value={recordData.otp} copyable token={token} />
            <InfoRow
              icon={faClock}
              label='Duration'
              value={`${
                calculateDuration(recordData.startTime, recordData.endTime).hours
                  ? `${calculateDuration(recordData.startTime, recordData.endTime).hours}h `
                  : ''
              }${calculateDuration(recordData.startTime, recordData.endTime).minutes}m`}
              token={token}
            />
          </>
        )}
      </div>
    </Card>
  )
}

export default BookingSummary
